export default {
  xs: 'w-6 h-6 p-0.5',
  sm: 'w-7 h-7 p-1',
  md: 'w-10 h-10 p-1.5',
  lg: 'h-11 w-11 p-1.5',
  xl: 'w-14 h-14 p-2',
}
